import React from 'react';
import { SaveOnSiteWorkEventForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';
import { useParams } from 'react-router-dom';

export type SaveOnSiteWorkEventModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: SaveOnSiteWorkEventModalProps) => {
  const params = useParams();
  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Save on site work event'
      subTitle='Enter details in order to save them to the system.'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <SaveOnSiteWorkEventForm.FC
        id={props.id}
        projectId={params.projectId ?? ''}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );

};
